/**
 * What the plans and add-ons are CALLED, in one place.
 *
 * The slugs are frozen in the database (`free` / `black` / `custom` are the
 * original three columns, long since renamed in the UI to CORE / PLUS / PRO).
 * Renaming a slug would orphan every feature_quotas row, so the mapping lives
 * here and only the labels ever change — see the entitlement gating notes.
 *
 * Extracted so the Stores panel and the Feature Matrix cannot drift into
 * calling the same plan two different things.
 */

export const COLUMN_LABELS = {
  free: 'CORE',
  black: 'PLUS',
  custom: 'PRO',
  'addon:ecommerce_manager': 'E-Commerce Manager',
  'addon:sales_advisor': 'Sales Advisor',
  'addon:admin_assistant': 'Admin Assistant',
  'addon:accounting': 'Bookkeeper',
  'addon:intelligence': 'Intelligence',
  'addon:lead_gen': 'Lead Gen',
};

export const PLAN_OPTIONS = [
  { value: 'free', label: COLUMN_LABELS.free },
  { value: 'black', label: COLUMN_LABELS.black },
  { value: 'custom', label: COLUMN_LABELS.custom },
];

export const ADDON_LABELS = {
  'addon:ecommerce_manager': COLUMN_LABELS['addon:ecommerce_manager'],
  'addon:sales_advisor': COLUMN_LABELS['addon:sales_advisor'],
  'addon:admin_assistant': COLUMN_LABELS['addon:admin_assistant'],
  'addon:accounting': COLUMN_LABELS['addon:accounting'],
  'addon:intelligence': COLUMN_LABELS['addon:intelligence'],
  'addon:lead_gen': COLUMN_LABELS['addon:lead_gen'],
};

/** One line per plan, so the picker explains itself without an overlay. */
export const PLAN_BLURB = {
  free: 'The core product — listings, deals, clients.',
  black: 'Everything in CORE, plus the sourcing and pricing tools.',
  custom: 'Everything, with every add-on included.',
};

export const planLabel = (slug) => COLUMN_LABELS[slug] || (slug ? String(slug).toUpperCase() : null);
